import { render, staticRenderFns } from "./PreApproveModelRiskForm.vue?vue&type=template&id=3f208e12&scoped=true&"
import script from "./PreApproveModelRiskForm.vue?vue&type=script&lang=js&"
export * from "./PreApproveModelRiskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f208e12",
  null
  
)

export default component.exports